// extracted by mini-css-extract-plugin
export default {"select-custom":"style_select-custom__5g5VA","task-error":"style_task-error__lVhUP","container-combine":"style_container-combine__RYi8N","combine-line":"style_combine-line__E+gy2"};